class SellingPlanSelector extends HTMLElement {

    constructor() {
        super();
        this.cartDrawerItem = this.closest(".m-cart-drawer--item");
        this.itemId = this.cartDrawerItem.id;

        const dataset = this.cartDrawerItem.dataset;
        this.itemLine = dataset.index;
        this.itemQuantity = dataset.quantity;

        this.sellingPlan = dataset.sellingPlan;

        this.checkBox = this.querySelector("#add_subscription_checkbox");
        this.checkBox.addEventListener("click", () => {
            this.changeSellingPlan();
        });
    }

    async changeSellingPlan() {
        this.sellingPlanChecked = this.querySelector("#add_subscription_checkbox").checked;
        let body = {};
        if (this.sellingPlanChecked == true) {
            console.log(this.itemQuantity);
            body = JSON.stringify({
                'line': Number(this.itemLine),
                'quantity': Number(this.itemQuantity),
                'selling_plan': Number(this.sellingPlan),
                'sections': 'cart-drawer',
                "sections_url": window.location.pathname
            });
        } else {
            body = JSON.stringify({
                'line': Number(this.itemLine),
                'quantity': Number(this.itemQuantity),
                'selling_plan': null,
                'sections': 'cart-drawer',
                "sections_url": window.location.pathname
            });
        }

        await fetch(`/cart/change.js`, { ...this.fetchConfig(), body: body })
            .then((response) => {
                return response.text();
            })
            .then((state) => {
                const parsedState = JSON.parse(state);
                this.newDom = new DOMParser().parseFromString(parsedState.sections['cart-drawer'], 'text/html');
                const shippingBarWrapper = document.querySelector('.shipping_bar_wrapper');
                if(shippingBarWrapper) {
                    shippingBarWrapper.innerHTML = this.newDom.querySelector('.shipping_bar_wrapper')?.innerHTML;
                }

                const cartDrawerBody = document.querySelector('.m-cart-drawer--body');
                if(cartDrawerBody) {
                    cartDrawerBody.innerHTML = this.newDom.querySelector(".m-cart-drawer--body")?.innerHTML;
                }

                const cartSummary = document.querySelector('.m-cart--summary');
                if(cartSummary) {
                    cartSummary.innerHTML = this.newDom.querySelector('.m-cart--summary')?.innerHTML;
                }
            }).catch((err) => {
                console.log(err);
            });
    }

    fetchConfig(type = "json") {
        return {
            method: "POST",
            headers: { "Content-Type": "application/json", Accept: `application/${type}` },
        };
    }
}

customElements.define('selling-plan-selector', SellingPlanSelector);

class QuantitySelector extends HTMLElement {
    constructor() {
        super();
        this.addEventListener("change", () => { this.changeQuantity() });
    }

    changeQuantity() {
        this.itemLine = this.closest(".m-cart-drawer--item").dataset.index; //added
        this.itemQuantity = this.querySelector("#quantity_select").value;
        const body = JSON.stringify({
            'line': Number(this.itemLine),
            'quantity': Number(this.itemQuantity),
            'sections': 'cart-drawer',
            "sections_url": window.location.pathname
        });
        fetch(`/cart/change.js`, { ...this.fetchConfig(), body: body }) //  statt change add.js
            .then((response) => {
                return response.text();
            })
            .then((state) => {
                const parsedState = JSON.parse(state);
                this.newDom = new DOMParser().parseFromString(parsedState.sections['cart-drawer'], 'text/html');
                const shippingBarWrapper = document.querySelector('.shipping_bar_wrapper');
                if(shippingBarWrapper) {
                    shippingBarWrapper.innerHTML = this.newDom.querySelector('.shipping_bar_wrapper')?.innerHTML;
                }

                const cartDrawerBody = document.querySelector('.m-cart-drawer--body');
                if(cartDrawerBody) {
                    cartDrawerBody.innerHTML = this.newDom.querySelector(".m-cart-drawer--body")?.innerHTML;
                }

                const cartSummary = document.querySelector('.m-cart--summary');
                if(cartSummary) {
                    cartSummary.innerHTML = this.newDom.querySelector('.m-cart--summary')?.innerHTML;
                }
            }).catch((err) => {
                console.log(err);
            });
    }

    fetchConfig(type = "json") {
        return {
            method: "POST",
            headers: { "Content-Type": "application/json", Accept: `application/${type}` },
        };
    }
}
customElements.define('quantity-selector', QuantitySelector)

class UpsellingProducts extends HTMLElement {

    constructor() {
        super()
        this.slideIndex = 1;
        this.querySelector(".prev").addEventListener("click", () => { this.plusSlides(-1) })
        this.querySelector(".next").addEventListener("click", () => { this.plusSlides(1) })
        

        if (window.innerWidth < 401) {
            this.showSlides(this.slideIndex);
        }
        window.addEventListener('resize', () => {
            if (window.innerWidth < 401) {
                this.showSlides(this.slideIndex);
            } else if (window.innerWidth > 400) {
                this.hideSlides()
            }
        });

        // swipe functionality
        this.touchstartX = 0
        this.touchendX = 0
        if (document.querySelector(".upselling_products_wrapper").classList.contains("slides_active")) {
            this.addEventListener('touchstart', e => {
                this.touchstartX = e.changedTouches[0].screenX
            })

            this.addEventListener('touchend', e => {
                this.touchendX = e.changedTouches[0].screenX
                this.checkDirection()
            })
        }

    }

    checkDirection() {
        let swipeAmount = this.touchendX - this.touchstartX 
        if (swipeAmount > 50) {
            this.plusSlides(1)
        }
        if (swipeAmount < -50) {
            this.plusSlides(-1)
        }
    }

    plusSlides(n) {
        this.showSlides(this.slideIndex += n);
    }
    hideSlides() {
        let slides = document.getElementsByClassName("mySlides");
        for (let i = 0; i < slides.length; i++) {
            slides[i].style.display = "block";
            document.querySelector(".upselling_products_wrapper").classList.remove("slides_active")
        }
    }
    showSlides(n) {
        let slides = document.getElementsByClassName("mySlides");
        if (n > slides.length) { this.slideIndex = 1 }
        if (n < 1) { this.slideIndex = slides.length }
        for (let i = 0; i < slides.length; i++) {
            slides[i].style.display = "none";
        }
        slides[this.slideIndex - 1].style.display = "block";
        document.querySelector(".upselling_products_wrapper").classList.add("slides_active")
    }
}
customElements.define('upselling-products', UpsellingProducts)

class UpsellingItem extends HTMLElement {
    constructor() {
        super()
        // added
        this.upsellingItem = this.querySelector("product-form");
        if(!this.upsellingItem.innerHTML.includes("form method")) {
            this.atcButton = this.querySelector(".add-to-cart")
            this.atcButton.remove()
            let newHTML = this.upsellingItem.innerHTML + `
            <div
                class="add-to-cart_custom sf__btn_custom"
                    
                    {% if variant.available == false %}disabled{% endif %}
                    aria-label="{{ 'products.product.add_to_cart' | t }}"
                >
                  <span class="atc-text_custom" data-atc-text>ADD</span>
            </div>
            `
            this.upsellingItem.innerHTML = newHTML
            this.newAtcButton = this.querySelector(".add-to-cart_custom")
            this.newAtcButton.addEventListener("click", () => {
                const body = JSON.stringify({
                    'quantity': 1,
                    'id': this.upsellingItem.querySelector("input[data-selected-variant]").value,
                    'sections': 'cart-drawer',
                    "sections_url": window.location.pathname
                });
                fetch(window.Shopify.routes.root + 'cart/add.js', { ...this.fetchConfig(), body: body }) //  statt change add.js
                .then((response) => {
                    return response.text();
                })
                .then((state) => {
                    const parsedState = JSON.parse(state);
                    this.newDom = new DOMParser().parseFromString(parsedState.sections['cart-drawer'], 'text/html')
                    const customScroll = document.querySelector('.sf__custom_scroll');
                    if(customScroll) {
                        customScroll.innerHTML = this.newDom.querySelector('.sf__custom_scroll')?.innerHTML;
                    }

                    const shippingBarWrapper = document.querySelector('.shipping_bar_wrapper')
                    if(shippingBarWrapper) {
                        shippingBarWrapper.innerHTML = this.newDom.querySelector('.shipping_bar_wrapper')?.innerHTML;
                    }

                    const cartSummary = document.querySelector('.m-cart--summary');
                    if(cartSummary) {
                        cartSummary.innerHTML = this.newDom.querySelector('.m-cart--summary')?.innerHTML;
                    }
                }).catch((err) => {
                    console.log(err);
                })

            })
        }
    }

    fetchConfig(type = "json") {
        return {
            method: "POST",
            headers: { "Content-Type": "application/json", Accept: `application/${type}` },
        };
    }
}

customElements.define('cart-drawer-upselling-item', UpsellingItem)